import React from "react";

// components
import CardLine from "components/Cards/CardLine.js";

export default function Dashboard() {
  return (
    <>

      <div className="flex flex-wrap">        
        <div className="w-full px-4">
          <h6 className="text-xl block my-4 p-3 text-white rounded border border-solid bg-gray-800">Subscription Models</h6>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
            <CardLine header="All models and all features (Map Codes Not Included!)" title="1 Year Subscription" price="850" sku="subs12"
            desc="If you buy this package, you can use all products unlimitedly with a daily usage limit of 10 for 1 year. Map Codes Not Included!" img="year1.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
            <CardLine header="All models and all features (Map Codes Not Included!)" title="6 Month Subscription" price="550" sku="subs6"
            desc="If you buy this package, you can use all products unlimitedly with a daily usage limit of 10 for 6 months. Map Codes Not Included!" img="months6.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
            <CardLine header="All models and all features (Map Codes Not Included!)" title="3 Month Subscription" price="400" sku="subs3"
            desc="If you buy this package, you can use all products unlimitedly with a daily usage limit of 10 for 3 months. Map Codes Not Included!" img="months3.jpg"/>
        </div>
      </div>

      <div className="flex flex-wrap">        
        <div className="w-full px-4">
          <h6 className="text-xl block my-4 p-3 text-white rounded border border-solid bg-gray-800">AMG Activations</h6>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
            <CardLine header="W213, W205FL, W463, W222FL" title="IC213 AMG Menu Activation" price="100" sku="ic213amg"
            desc="This package provides AMG menu activation for IC213. It will provide you with the credits required to have a 280KM or 330KM speedometer." img="330km.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W222" title="IC222 Amg Menu" price="80" sku="ic222amg"
          desc="This package provides AMG menu activation for IC222." img="IC222amg.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W117, W176, W166" title="IC172 Amg Menu" price="50" sku="ic172amg"
          desc="In this package, you can use the IC172 cluster to enable AMG Menu." img="ic172amg.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W222" title="IC222 330KM" price="150" sku="ic222km"
          desc="This package provides 330KM for IC222." img="IC222amg.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W221, W216" title="KI221 Amg Menu" price="80" sku="ki221amg"
          desc="In this package, you can use the KI221 cluster to enable AMG Menu." img="KI221amg.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W205" title="IC205 Amg Menu" price="80" sku="ic205amg"
          desc="In this package, you can use the IC205 cluster to enable AMG Menu." img="IC205amg.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W204" title="IC204 Amg Menu" price="50" sku="ic204amg"
          desc="In this package, you can use the IC204 cluster to enable AMG Menu." img="IC204amg.jpg"/>
        </div>
      </div>
  
      <div className="flex flex-wrap">
        <div className="w-full px-4">
          <h6 className="text-xl block my-4 p-3 text-white rounded border border-solid bg-gray-800">Renewing Clusters</h6>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W213, W205FL, W463, W222FL" title="IC213 Renewing" price="150" sku="ic213renew"
          desc="In this package, you can use the IC213 cluster to make it virgin state. In this way, you can correct erroneous KM data." img="IC213Renew.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W222" title="IC222 Renew" price="150" sku="ic222renew"
          desc="In this package, you can use the IC222 cluster to make it virgin state. In this way, you can correct erroneous KM data." img="IC222renew.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W205 Facelift" title="IC213 Renew" price="150" sku="ic213renew"
          desc="In this package, you can use the IC213 cluster to make it virgin state." img="ic205flrenew.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W204" title="IC204 Renew" price="100" sku="ic204renew"
          desc="In this package, you can use the IC204 cluster to make it virgin state. In this way, you can correct erroneous KM data." img="IC204preamg.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W205" title="IC222 Renew" price="150" sku="ic205renew"
          desc="In this package, you can use the IC205 cluster to make it virgin state." img="ic205renew.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W117, W176, W166" title="IC172 Renew" price="80" sku="ic172renew"
          desc="In this package, you can use the IC172 cluster to make it virgin state." img="IC172Renew.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W221, W216" title="KI221 Renew" price="100" sku="ki221renew"
          desc="In this package, you can use the KI221 cluster to make it virgin state." img="KI221Renew.jpg"/>
        </div>
      </div>

      <div className="flex flex-wrap">
        <div className="w-full px-4">
          <h6 className="text-xl block my-4 p-3 text-white rounded border border-solid bg-gray-800">Editing Clusters</h6>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W213, W205FL, W463, W222FL" title="IC213/IC222 E2prom Editing" price="50" sku="ic213edit"
          desc="In this package, you can use it to read/write Eprom for IC213/IC222. This way, you can back up your data before making changes." img="ic213epromedit.jpg"/>
        </div>
        <div className="w-full xl:w-3/12 px-4">
          <CardLine header="W204" title="IC204 E2prom Edit" price="50" sku="ic204edit"
          desc="In this package, you can use it to read/write Eprom for IC204. This way, you can back up your data before making changes. " img="IC204renewwithnewprice.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W205" title="IC222 E2prom Editing" price="50" sku="ic205edit"
          desc="In this package, you can use it to read/write Eprom for IC222. This way, you can back up your data before making changes." img="ic205editwithnewprice.jpg"/>
        </div>
      </div>

      <div className="flex flex-wrap">
        <div className="w-full px-4">
          <h6 className="text-xl block my-4 p-3 text-white rounded border border-solid bg-gray-800">Navigation Codes</h6>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W221, W216 ETC." title="NTG3.5 Navigation Codes" price="30" sku="ntg35map"
          desc="Do you need Offline NTG3.5 Map Code? Here it is! Generate your offline pin code." img="ntg35map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W204, W212, W463, W207 ETC." title="NTG4.5 Navigation Codes" price="40" sku="ntg45map"
          desc="Do you need Offline NTG4.5 Map Code? Here it is! Generate your offline pin code." img="ntg45map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W205, W222, W470, W447" title="NTG5.0 Navigation Codes" price="50" sku="ntg50map"
          desc="Do you need Offline NTG5.0 Map Code? Here it is! Generate your offline pin code." img="ntg50map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W212/W207 Facelift, W117, W176, W166" title="NTG5s1 Navigation Codes" price="60" sku="ntg51map"
          desc="Do you need Offline NTG5s1 Map Code? Here it is! Generate your offline pin code." img="ntg51map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W213, W205FL, W463, W464" title="NTG5.5 Navigation Codes" price="70" sku="ntg55map"
          desc="Do you need Offline NTG5.5 Map Code? Here it is! Generate your offline pin code." img="ntg55map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W213FL, W205FL, W118, W177" title="NTG6.0 Navigation Codes" price="70" sku="ntg60map"
          desc="Do you need Offline NTG6.0 Map Code? Here it is! Generate your offline pin code." img="ntg60map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="ASTON MARTIN" title="NTG5.0 Navigation Codes" price="100" sku="astonntg50map"
          desc="Do you need Offline Aston Martin NTG5.0 Map Code? Here it is! Generate your offline pin code." img="astonntg50map.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 mb-12 xl:mb-0 px-4">
          <CardLine header="W213, W205FL, W463, W464" title="NTG5.5 Navigation Fix" price="70" sku="ntg55map" download="https://mega.nz/file/it1kESIT#1TiNhCcfdJFdsK0ZhXeBJp_-NFMp984DQH68FeQY-NM"
          desc="Do you need fix map installation of your NTG55? Here it is! Generate your offline pin code." img="navicodefix.jpg"/>
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardLine header="W117, W176, W166, W204, W222, W205, W213" title="Cluster Manual Coding" price="30" sku="ic213unlock"
          desc="In this package, you can code your cluster by entering HEX codes. This is for professional users." img="manualcoding.jpg"/>
        </div>

      </div>

    </>
  );
}
